import Swiper from "swiper";
import "swiper/css";
import { Navigation } from "swiper/modules";

export default new class HeurekaReviewScrollService {
    public init(): void {
        const slider = document.querySelector<HTMLDivElement>(".product-slider");

        if (slider === null) {
            return;
        }

        slider.classList.add("swiper");

        slider.insertAdjacentHTML("afterbegin", `
            <button class="product-slider-left" aria-label="Show previous review">
                <i class="fa-solid fa-caret-left"></i>
            </button>
        `);
        slider.insertAdjacentHTML("beforeend", `
            <button class="product-slider-right" aria-label="Show next review">
                <i class="fa-solid fa-caret-right"></i>
            </button>
        `);

        try {
            // eslint-disable-next-line no-new
            new Swiper(slider, {
                modules: [Navigation],
                slidesPerView: 1,
                loop: true,
                navigation: {
                    nextEl: ".product-slider-right",
                    prevEl: ".product-slider-left",
                },
                breakpoints: {
                    991: { slidesPerView: 4 },
                    768: { slidesPerView: 2 },
                },
            });
        } catch (error) {
            if (!(error instanceof TypeError)) {
                throw error;
            }

            // Do nothing
        }
    }
}();
